// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"1ebe5992","186":"b34bc44f","206":"fbd521ef","217":"127ff73e","326":"8b479a51","461":"31ce48e1","549":"3ee91a55","585":"8bb58922","600":"377f271e","649":"554295e3","963":"dcdf6304"}[chunkId] + ".chunk.js";
};